import {createAnatomy} from '@zag-js/anatomy';

export const tableFiltersMenuAnatomy = createAnatomy(`filters-menu`).parts(
  // TODO: go over all parts and update design
  `list`, // filterMenuGroup
  `item`, // filterMenuItem
  `group`,
  `groupTitle`,
  `option`,
  `searchInput`,
  `panelHeader`,
  `itemOption`,
  // `filterMenuItemOption`,
  // `searchInput`,
  // `filterCtaMenuItem`,
  // `saveFilterButton`,
);

export const parts = tableFiltersMenuAnatomy.build();

export type Part = keyof typeof parts;
